import React, { useEffect, useState, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { Loader } from "semantic-ui-react";
import BCMessage from "../ui/BCMessage";
import BCTabMenuBar from "../ui/BCTabMenuBar";
import BCDashboard from "../ui/BCDashboard";
import BCDashboardFeed from "../ui/BCDashboardFeed";
import BCDashboardButtons from "../ui/BCDashboardButtons";
import BCActionMenu from "../ui/BCActionMenu";
import BCTable from "../ui/BCTable";
import { getDeals, getDeal, getLODashboard } from "../../api/LOApi";
import { getMockDeals, getMockDeal, getMockLODashboard } from "../../api/mock/MockLOApi";
import { FeatureFlags } from "../constants/LocalServerConstants";

const LODeal = ({ 
  isGreaterThanMobile, 
  isGreaterThanTablet, 
  isSidebar, 
  isMessage, 
  setIsMessage, 
  errorResponse, 
  setErrorResponse,
  deal, 
  setDealData 
}) => {
  const LODealTabs = [
    "Loan Details",
    "Properties",
    "Entities",
    "Documents",
    "Messaging",
    "Comments",
    "Change Log"
  ];
  const [isLoading, setIsLoading] = useState(false);
  const [dashboardData, setDashboardData] = useState(undefined as any);
  const [loDeal, setLODeal] = useState(undefined as any);
  const [activeTab, setActiveTab] = useState(LODealTabs[0].toLocaleUpperCase());

  const history = useHistory();
  const handleError = useCallback(() => {
    history.push("/error");
  }, [history]);

  const handleNavigateToActivities = useCallback(() => {
    history.push("/activities");
  }, [history]);

  const handleAction = (action) => {
    switch(action) {
      case "Review":
        FeatureFlags.IS_DEBUG && console.log("Review");
        break;
      case "Archive":
        FeatureFlags.IS_DEBUG && console.log("Archive");
        break;
      case "Download":
        FeatureFlags.IS_DEBUG && console.log("Download");
        break;
      default:
        FeatureFlags.IS_DEBUG && console.log("default");
    }
  };

  useEffect(() => {
    const getLODealsAsync = async () => {
      try {
        const response = FeatureFlags.IS_MOCK ? await getMockDeals() : await getDeals();
        if (response && response.ok) {
          setIsMessage(false);
          setDealData(await response.json());
        }
        else {
          FeatureFlags.IS_DEBUG && console.log(response);
          setIsMessage(true);
        }
      }
      catch (error) {
        FeatureFlags.IS_DEBUG && console.log(error);
        setIsMessage(false);
        handleError();
      }
      setIsLoading(false);
    };

    const getLODealAsync = async (id) => {
      try {
        const response = FeatureFlags.IS_MOCK ? await getMockDeal(id) : await getDeal(id);
        if (response && response.ok) {
          setIsMessage(false);
          setLODeal(await response.json());
        }
        else {
          FeatureFlags.IS_DEBUG && console.log(response);
          setErrorResponse(response);
          setIsMessage(true);
        }
      }
      catch (error) {
        FeatureFlags.IS_DEBUG && console.log(error);
        setIsMessage(false);
        handleError();
      }
      setIsLoading(false);
    };

    const getLODashboardAsync = async () => {
      try {
        const response = FeatureFlags.IS_MOCK ? await getMockLODashboard() : await getLODashboard();
        if (response && response.ok) {
          setIsMessage(false);
          setDashboardData(await response.json());
        }
        else {
          FeatureFlags.IS_DEBUG && console.log(response);
          setIsMessage(true);
        }
      }
      catch (error) {
        FeatureFlags.IS_DEBUG && console.log(error);
        setIsMessage(false);
        handleError();
      }
      setIsLoading(false);
    };

    if (deal === undefined) {
      setIsLoading(true);
      getLODealsAsync();
    }
    else {
      getLODashboardAsync();
      getLODealAsync(deal.id);
    }
    
  }, [setIsMessage, handleError, deal, setDealData]);

  const LODealDetailsLayout = [
    [
      {
        title: "Loan Quote",
        size: 12,
        content: <div>Loan Quote</div>
      },
      {
        title: "Activities",
        size: 4,
        content: <BCDashboardFeed data={dashboardData && dashboardData.alerts} />,
        footer: <BCDashboardButtons handleSeeAll={handleNavigateToActivities} />
      }
    ]
  ];

  const LODealPropertiesLayout = [
    [
      {
        title: `${loDeal && loDeal.summary.property} Properties`,
        size: 16,
        content: <div>Loan Properties</div>
      }
    ]
  ];

  const LODealDocumentsLayout = [
    [
      {
        size: 16,
        content: <div>
          <BCActionMenu actions={[
            {
              name: "Review",
              event: handleAction
            },
            {
              name: "Archive",
              event: handleAction
            },
            {
              name: "Download",
              event: handleAction
            },
          ]}/>
          <BCTable data={loDeal && loDeal.documents} />
        </div>
      }
    ]
  ];

  return (
    <div className={(isGreaterThanTablet && isSidebar) ? "landing-page hide-sidebar" : "landing-page sidebar"}>
      {isLoading ? <Loader active inline="centered" size={"big"} /> : <div>
        <BCMessage
          animation={"fly down"}
          duration={750}
          visible={isMessage}
          transitionOnMount
          styles="full-width"
          onDismiss={() => setIsMessage(false)}
          errorResponse={errorResponse}
        />
        {deal && <div>
          <BCTabMenuBar 
            title={loDeal && `${loDeal.summary.name} - ${loDeal.summary.property}, ${loDeal.summary.city}, ${loDeal.summary.state}`} 
            tabs={LODealTabs} 
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
          <BCDashboard
            DashboardLayout={activeTab ===  LODealTabs[0].toLocaleUpperCase() ? LODealDetailsLayout :
              activeTab ===  LODealTabs[1].toLocaleUpperCase() ? LODealPropertiesLayout : 
              activeTab ===  LODealTabs[3].toLocaleUpperCase() ? LODealDocumentsLayout : []}
            isGreaterThanMobile={isGreaterThanMobile}
          />
        </div>}
      </div>}
    </div>
  );
};

export default LODeal;